import createTheme from '@material-ui/core/styles/createTheme';
import breakpoints from './breakpoints';
import overrides from './overrides';
import palette from './palette';
import props from './props';
import shadows from './shadows';
import shape from './shape';
import spacing from './spacing';
import typography from './typography';
export const themeObject = {
  breakpoints,
  overrides,
  palette,
  props,
  shadows,
  spacing,
  shape,
  typography
};
export default createTheme(themeObject);
export * from './shadows';